var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 5.72842H2.4C1.072 5.72842 0 6.78718 0 8.09878V12.3395C0 12.6157 0.223858 12.8395 0.5 12.8395H3.2V15.5C3.2 15.7761 3.42386 16 3.7 16H12.3C12.5761 16 12.8 15.7761 12.8 15.5V12.8395H15.5C15.7761 12.8395 16 12.6157 16 12.3395V8.09878C16 6.78718 14.928 5.72842 13.6 5.72842ZM11.2 14.4198H4.8V10.4691H11.2V14.4198ZM13.6 8.8889C13.16 8.8889 12.8 8.53335 12.8 8.09878C12.8 7.66421 13.16 7.30866 13.6 7.30866C14.04 7.30866 14.4 7.66421 14.4 8.09878C14.4 8.53335 14.04 8.8889 13.6 8.8889ZM12.8 0.5C12.8 0.223858 12.5761 0 12.3 0H3.7C3.42386 0 3.2 0.223858 3.2 0.5V4.43829C3.2 4.71444 3.42386 4.93829 3.7 4.93829H12.3C12.5761 4.93829 12.8 4.71444 12.8 4.43829V0.5Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.f6ed9eb27f4112e0bac26a0fd9aae46c.svg";
export { ForwardRef as ReactComponent };